import { render } from "./simplecancellation-count.vue?vue&type=template&id=3fff915e&scoped=true"
import script from "./simplecancellation-count.vue?vue&type=script&lang=js"
export * from "./simplecancellation-count.vue?vue&type=script&lang=js"

import "./simplecancellation-count.vue?vue&type=style&index=0&id=3fff915e&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fff915e"]])

export default __exports__